import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  variant?: 'success' | 'warning' | 'error';
  duration?: number;
  onDismiss: () => void;
}

const variantStyles = {
  success: 'bg-green-600 text-white',
  warning: 'bg-amber-500 text-white',
  error: 'bg-red-600 text-white',
};

export const Toast: React.FC<ToastProps> = ({
  message,
  variant = 'success',
  duration = 4000,
  onDismiss,
}) => {
  useEffect(() => {
    const timer = setTimeout(onDismiss, duration);
    return () => clearTimeout(timer);
  }, [duration, onDismiss]);

  return (
    <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-lg ${variantStyles[variant]}`}>
      <span className="text-sm font-medium">{message}</span>
      <button
        onClick={onDismiss}
        className="ml-1 text-white/80 hover:text-white transition-colors text-lg leading-none"
      >
        &times;
      </button>
    </div>
  );
};
